module.exports = __webpack_public_path__ + "img/mySignatureEle.f33e5caa.svg";